import { queryClient } from '~/services/query-client/queryClient';

import {
  EventAlertsPaginatedResponse,
  UNREAD_COUNT_QUERY_KEY,
} from './event-alerts-query-keys';

export const faviconLinks = {
  default: '/app/static/images/brand/favicon.svg',
  notification: '/app/static/images/brand/favicon-notification.svg',
};

export const updateAlertsFavicon = () => {
  const queryData = queryClient.getQueryData<EventAlertsPaginatedResponse>(
    UNREAD_COUNT_QUERY_KEY
  );
  const unreadCount = queryData?.pages[0]?.count;
  const faviconElement = document.querySelector("link[rel*='icon']");
  faviconElement?.setAttribute(
    'href',
    unreadCount ? faviconLinks.notification : faviconLinks.default
  );
};
